import React from "react";

const CheckboxCheckedGreenIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16675 1.66666H15.8334C17.2141 1.66666 18.3334 2.78594 18.3334 4.16666V15.8333C18.3334 17.214 17.2141 18.3333 15.8334 18.3333H4.16675C2.78604 18.3333 1.66675 17.214 1.66675 15.8333V4.16666C1.66675 2.78594 2.78604 1.66666 4.16675 1.66666ZM14.8334 7.16666C15.1096 6.79847 15.0349 6.27613 14.6667 5.99999C14.2986 5.72385 13.7762 5.79847 13.5001 6.16666L9.07659 12.0647L6.42267 9.41073C6.09723 9.0853 5.5696 9.0853 5.24416 9.41073C4.91872 9.73617 4.91872 10.2638 5.24416 10.5892L7.89808 13.2432C8.61526 13.9603 9.80137 13.876 10.4099 13.0647L14.8334 7.16666Z"
        fill="#10B981"
      />
    </svg>
  );
};

export default CheckboxCheckedGreenIcon;
